import { render, staticRenderFns } from "./PostUserTabs.vue?vue&type=template&id=11b7d920&"
import script from "./PostUserTabs.vue?vue&type=script&lang=js&"
export * from "./PostUserTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports